import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

interface UserProfile {
  name: string;
  email: string;
  phoneNumber: string;
  dateCreated: string;
}

const ProfilePage = () => {
  const { t, i18n } = useTranslation();
  const [user, setUser] = useState<UserProfile | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const navigate = useNavigate();

  useEffect(() => {
    const token = localStorage.getItem('jwt');
    if (!token) {
      setError(t('profile.loginRequired'));
      setLoading(false);
      return;
    }
    fetch('/api/auth/me', {
      headers: { 'Authorization': `Bearer ${token}` }
    })
      .then(async res => {
        if (res.ok) {
          const data = await res.json();
          setUser(data);
        } else {
          setError(t('profile.authRequired'));
        }
      })
      .catch(() => setError(t('common.networkError')))
      .finally(() => setLoading(false));
  }, [t]);

  if (loading) {
    return <div className="flex justify-center items-center h-64">{t('common.loading')}</div>;
  }
  if (error) {
    return <div className="flex flex-col items-center justify-center h-64 text-red-600">
      <div>{error}</div>
      <button className="mt-4 px-4 py-2 bg-blue-600 text-white rounded" onClick={() => navigate('/')}>{t('profile.backToHome')}</button>
    </div>;
  }
  if (!user) return null;

  return (
    <div className="max-w-md mx-auto mt-12 bg-white shadow-lg rounded-lg p-8" dir={i18n.language === 'he' ? 'rtl' : 'ltr'}>
      <h1 className="text-2xl font-bold mb-6 text-center">{t('profile.title')}</h1>
      <div className="mb-4">
        <span className="font-semibold">{t('profile.name')}:</span> {user.name}
      </div>
      <div className="mb-4">
        <span className="font-semibold">{t('profile.email')}:</span> {user.email}
      </div>
      <div className="mb-4">
        <span className="font-semibold">{t('profile.phone')}:</span> {user.phoneNumber}
      </div>
      <div className="mb-4">
        <span className="font-semibold">{t('profile.registeredDate')}:</span> {new Date(user.dateCreated).toLocaleDateString(i18n.language === 'he' ? 'he-IL' : 'en-US')}
      </div>
      <button className="w-full bg-blue-600 text-white py-2 rounded mt-6" disabled>{t('profile.editProfile')}</button>
    </div>
  );
};

export default ProfilePage; 